import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';

//components
import { toast } from "react-toastify";
import { Button, Card, Col, Form, Row} from "react-bootstrap"
import Error from "../../../../../../components/Error";
import { Modal } from "../../../../../../components/modal";

//services
import { managerUserChangePassword } from "../../../../../../services/profile.service";
import { PasswordGenerator } from "../../../../components/password-generator";

const validationSchemaPassword = Yup.object({
    password: Yup.string().required("Sua senha não pode ficar em braco").min(8, 'Sua senha precisa ser maior que 8 caracteres'),
}).required();

export const CardAccessDetail = (props: any): JSX.Element => {
    const { user } = props;
    const { t: translation } = useTranslation();

    const [loadingModal, setLoadingModal] = useState<boolean>(false);
    const [updatePassword, setUpdatePassword] = useState<boolean>(false);

    const { setValue, handleSubmit: handleSubmitPassword, formState: { errors: errorsPassword } } = useForm({ resolver: yupResolver(validationSchemaPassword) });

    const [, setStrengthPassword] = useState<number>(0);
    const [cleanPassword] = useState<boolean>(false);

    const onSubmitPassword = (formPassword: any) => {
        setLoadingModal(true)
        managerUserChangePassword(user.id, formPassword).then(() => {
            setLoadingModal(false)
            setUpdatePassword(false);
        }).catch((err) => {
            setLoadingModal(false)
            toast.error(err.response.data[0]);
        })
    }

    return (
        <Card className="card-detail">
            <Card.Body>
                <Card.Title>
                    <Row>
                        <Col xs={12} className="d-flex align-items-center">
                            <h4 className="mb-0 text-darker-grey" style={{ fontSize: '22px' }}>{translation('userAccount.access')}</h4>
                        </Col>
                    </Row>
                </Card.Title>
                <Row className="mt-3 p-0">
                    <hr />
                </Row>
                <Row >
                    <Col md={12} className="d-flex align-items-center">
                        <Row className="col-12">
                            <Col xs={12} className="mb-3">
                                <Row>
                                    <Col sm={12}>
                                        <h6>
                                            <span className="text-darker-grey">{translation('userAccount.email')}: </span>
                                            {user.email}
                                        </h6>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Row>
                                    <Col sm={6}>
                                        <h6><span className="text-darker-grey">{translation('userAccount.password')}:</span> ********</h6>
                                    </Col>
                                    <Col sm={6} className="d-flex justify-content-end p-0">
                                        <Button variant="link" style={{ textDecoration: 'none' }} onClick={() => setUpdatePassword(true)}>{translation('userAccount.updatePassword')}</Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Row>
                                    <Col sm={6}>
                                        <h6><span className="text-darker-grey">{translation('userAccount.lastLogin')}</span></h6>
                                    </Col>
                                    <Col sm={6} className="d-flex justify-content-end text-darker-grey">
                                        {user.last_login ? `Há ${user.last_login} ${user.last_login > 1 ? 'dias' : 'dia'}` : "Nunca fez login"}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Row>
                                    <Col sm={6}>
                                        <h6>
                                            <span className="text-darker-grey">
                                                {
                                                    user.status === 'Assinante' ? (
                                                        translation('userAccount.usedMaterials')
                                                    ) : (
                                                        <>
                                                            {
                                                                user.status === 'Parceiro' ? (
                                                                    translation('userAccount.registeredMaterials')
                                                                ) : (
                                                                    translation('userAccount.viewedMaterials')
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                            </span>
                                        </h6>
                                    </Col>
                                    <Col sm={6} className="d-flex justify-content-end text-darker-grey">
                                        {
                                            user.status === 'Assinante' ? (
                                                user.user_information ? user.user_information.materials_used : 0
                                            ) : (
                                                <>
                                                    {
                                                        user.status === 'Parceiro' ? (
                                                            user.user_information ? user.user_information.registered_materials : 0
                                                        ) : (
                                                            user.user_information ? user.user_information.visualized_materials : 0
                                                        )
                                                    }
                                                </>
                                            )
                                        } {user.status === 'Parceiro' ? "materiais" : "disciplinas"}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>

            <Modal
                headerTitle={translation('userAccount.updatePassword')}
                submitButtonText={translation('save')}
                show={updatePassword}
                onHide={() => setUpdatePassword(false)}
                onSubmit={handleSubmitPassword(onSubmitPassword)}
                variant="form-modal"
                loading={loadingModal}
            >
                <Form>
                    <Form.Group className="mb-2">
                        <PasswordGenerator setValue={setValue} setStrengthPassword={setStrengthPassword} cleanPassword={cleanPassword} />
                        {errorsPassword.password ? (<div className="w-100"> <Error>{errorsPassword.password?.message}</Error> </div>) : ""}
                    </Form.Group>
                </Form>
            </Modal>
        </Card>
    )
}